import styled from '../../../../styles/styledComponents/themeComponents';

export const ImagePairStyle = styled.div`
  display: flex;
  gap: 24px;

  .image-column {
    flex: 1;
    min-width: 0;

    .column-header {
      font-size: 13px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }

    .size-guide {
      margin-top: 6px;
      font-size: 11px;
      font-weight: 600;
      color: #6200ea;
      line-height: 1.6;
    }
  }
`;
